exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\n  background-color: #104E8B;\n  color: whitesmoke;\n  font-family: \"Microsoft YaHei\" ! important;\n  font-size: 16px;\n}\n.header2 {\n  height: 60px;\n  line-height: 60px;\n  font-size: 20px;\n}\n.content {\n  padding-top: 40px;\n}\n.footer2 {\n  height: 40px;\n  line-height: 40px;\n  font-size: 14px;\n  padding-left: 15px;\n}\n.jss-transparent {\n  background-color: rgba(255, 255, 255, 0.15);\n  /* IE9、标准浏览器、IE6和部分IE7内核的浏览器(如QQ浏览器)会读懂 */\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./src/views/handCheck/HandCheck.less
// module id = oQmD
// module chunks = 1